var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProductivityGraphIcon = function SvgProductivityGraphIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.25 48C37.5048 48 48.25 37.2548 48.25 24C48.25 10.7452 37.5048 0 24.25 0C10.9952 0 0.25 10.7452 0.25 24C0.25 37.2548 10.9952 48 24.25 48Z",
    fill: "url(#paint0_linear_3813_1043)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3813_1043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1019 32.2573C20.1019 33.378 19.0087 33.6166 18.6919 33.6626C17.9512 33.6419 17.3552 33.021 17.3552 32.2573V14.8788H25.5953V13H16.4396C15.9342 13 15.524 13.4208 15.524 13.9394V32.2573C15.524 34.0703 16.9615 35.5451 18.7286 35.5451H32.4621C34.2292 35.5451 35.6667 34.0703 35.6667 32.2573V30.8482H20.1019V32.2573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0888 24.2725C29.7273 24.2725 28.4657 23.831 27.4265 23.0852V28.9694L31.0888 26.1513L34.7511 28.9694V23.0852C33.7119 23.831 32.4503 24.2725 31.0888 24.2725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0887 22.3938C33.617 22.3938 35.6666 20.2909 35.6666 17.6969C35.6666 15.1029 33.617 13 31.0887 13C28.5604 13 26.5109 15.1029 26.5109 17.6969C26.5109 20.2909 28.5604 22.3938 31.0887 22.3938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3813_1043",
    x1: 8.19287,
    y1: 7,
    x2: 37.6929,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DCEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DCE96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3813_1043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(13.6929 13)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProductivityGraphIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ProductivityGraphIcon.589421fb3e6e7091307918bbf0aec127.svg";